<div
    class="post-card border border-1 rounded mb-2"
    [class.border-danger]="!post.imInCharge && !post.userInChargeId"
    [class.border-success]="post.imInCharge"
    [class.border-success]="!post.imInCharge && post.userInChargeId"
    [class.taken]="post.userInChargeId">
    <div class="post-detail">
        @if (post.imInCharge) {
            <span class="post-detail__assigned bg-success">Assigned to me</span>
        }
        @if (!post.imInCharge && post.userInChargeId) {
            <span class="post-detail__assigned bg-success">Assigned to {{ post.userInChargeName }}</span>
        }
        @if (!post.imInCharge && !post.userInChargeId) {
            <span class="post-detail__assigned bg-danger">Unassigned</span>
        }
        <div>
            <p class="mb-0">
                <span class="small text-muted d-block">
                    @if (post.isVoided) {
                        <span class="badge bg-danger post-status">VOIDED</span>
                    }
                    @if (post.isProcessed) {
                        <span class="badge bg-success post-status">PROCESSED</span>
                    }
                    {{ post.appointmentType }}
                </span>
                <span [class.text-danger]="!post.userInChargeId" [class.text-success]="post.userInChargeId"
                    ><b>{{ post.postType }}</b></span
                >
                <br />
            </p>
            <div class="d-flex gap-1">
                @if (post.isBillable && !post.isInvoiced) {
                    <span class="badge bg-warning small" ngbTooltip="Invoice Missing" placement="bottom">
                        <fa-icon [icon]="['fas', 'file-invoice']"></fa-icon>
                    </span>
                }
                @if (post.postImagesCount) {
                    <span
                        class="badge text-bg-success small"
                        ngbTooltip="{{ post.postImagesCount }} Images Attached"
                        placement="bottom">
                        <fa-icon [icon]="['fas', 'image']"></fa-icon> {{ post.postImagesCount }}
                    </span>
                }
                @if (post.isBillable && !post.isPaymentReceived) {
                    <span class="badge bg-warning small" ngbTooltip="Outstanding payment" placement="bottom">
                        <fa-icon [icon]="['fas', 'pound-sign']"></fa-icon>
                    </span>
                }
                @if (post.isUrgent) {
                    <span class="badge bg-danger small" ngbTooltip="Urgent" placement="bottom">
                        <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
                    </span>
                }
                @if (post.isWarranty) {
                    <span class="badge bg-warning small" ngbTooltip="Main Boiler Under Warranty" placement="bottom">
                        <fa-icon [icon]="['fas', 'star']"></fa-icon>
                    </span>
                }
                @if (post.isGuarantee) {
                    <span class="badge bg-warning small" ngbTooltip="Main Boiler Under Guarantee" placement="bottom">
                        <fa-icon [icon]="['fas', 'star']"></fa-icon>
                    </span>
                }

                <span
                    [class.bg-success]="post.postNotesCount"
                    [class.bg-warning]="!post.postNotesCount"
                    class="badge bg-warning small"
                    ngbTooltip="Click for notes"
                    (click)="sfNotes.open()"
                    placement="bottom">
                    <fa-icon [icon]="['fas', 'sticky-note']"></fa-icon> {{ sfNotes.count }}
                </span>

                @if (post.isFreeOfCharge) {
                    <span class="badge bg-danger small" ngbTooltip="Free of Charge" placement="bottom">
                        <fa-icon [icon]="['fas', 'money-bill-transfer']"></fa-icon>
                    </span>
                }
                @if (post.isBillable && post.isPaymentExpected) {
                    <span class="badge bg-danger small" ngbTooltip="Payment was expected on site" placement="bottom">
                        <fa-icon [icon]="['fas', 'pound-sign']"></fa-icon>
                    </span>
                }
            </div>
        </div>
        <div>
            <p class="mb-0 small">
                Post Id: <span class="post-id">{{ post.id }}</span
                ><br />
                <span ngbTooltip="Received at {{ post.createdDate | date: 'dd/MM/yyyy HH:mm:ss' }}" container="body"
                    >Received <b>{{ post.createdDate | dateago }}</b></span
                >
            </p>
        </div>
        <div class="small">
            <a [routerLink]="['/customers', post.customerId, 'details']">
                <p class="mb-0 small">
                    Customer:<br />
                    {{ post.customerName }}<br />
                    {{ post.customerAddressLine1 ?? '' | truncate: 20 }}
                </p>
            </a>
        </div>
        <div class="d-none d-xl-block">
            @if (post.staffId) {
                <img class="engineer-image" [src]="post.staffImage" [alt]="post.staffName" />
                <span class="ms-3 small fw-bold"
                    ><a routerLink="/staff/{{ post.staffId }}">{{ post.staffName }}</a></span
                >
            }
        </div>
        <!-- <div class="controls">
            <a sfButton type="button" size="sm" color="clear" icon="chevron-right" routerLink="/posts/{{ post.id }}"></a>
            <button sfButton type="button" size="sm" color="clear" icon="chevron-right" (click)="postClick()"></button>
        </div> -->
    </div>
    <div class="bottom-controls">
        <div class="row align-items-center">
            <ng-container *ngxPermissionsOnly="'ADMIN'">
                <div class="col-6 col-md-auto">
                    <label class="small" [for]="'staff-for-post-' + post.id"
                        >{{ post.userInChargeId ? 'Assigned to' : 'Assign to' }}:</label
                    >
                </div>
                <div class="col-6 col-md-auto col-lg-4 col-xl-3 col-xxl-3">
                    <ng-select
                        [items]="postStore.staff()"
                        bindValue="id"
                        bindLabel="fullName"
                        [(ngModel)]="post.userInChargeId"
                        placeholder="Assign to..."
                        (change)="assignPostToStaff($event)">
                        <ng-option [value]="null">Unassigned</ng-option>
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <span [ngOptionHighlight]="search">{{ item.fullName }} ({{ item.id }})</span>
                        </ng-template></ng-select
                    >
                </div>
            </ng-container>
            <ng-container *ngxPermissionsExcept="'ADMIN'">
                <div class="col-12 col-md-auto text-center text-md-start">
                    @if (post.userInChargeId) {
                        <button
                            sfButton
                            type="button"
                            color="danger"
                            size="sm"
                            icon="unlink"
                            tooltip="Release this post"
                            (click)="unTakePost()">
                            Release
                        </button>
                    } @else {
                        <button
                            sfButton
                            type="button"
                            color="secondary"
                            size="sm"
                            icon="link"
                            tooltip="Take charge of this post"
                            (click)="takePost()">
                            Take
                        </button>
                    }
                </div></ng-container
            >
            <div class="col-12 mt-3 mt-md-0 text-center text-md-end col-md-auto ms-md-auto">
                <div class="btn-group btn-group-sm">
                    <button
                        sfButton
                        #sfNotes="sfNotes"
                        sfNotes
                        [initialCount]="post.postNotesCount"
                        type="button"
                        color="secondary"
                        icon="sticky-note"
                        [postId]="post.id">
                        Notes
                        @if (sfNotes.count) {
                            <span class="badge text-bg-danger">{{ sfNotes.count }}</span>
                        }
                    </button>
                    @switch (post.postTypeId) {
                        <!-- Quote Wizard -->

                        @case (51) {
                            <a
                                sfButton
                                icon="file-pen"
                                size="sm"
                                [tooltip]="processTooltip"
                                href="{{ legacyUrl }}public/certificate/{{ post.companyId }}/{{ post.t1 }}"
                                target="_blank"
                                >View</a
                            >
                        }
                        <!-- Quick quote -->

                        @case (45) {
                            <a
                                sfButton
                                icon="file-pen"
                                [tooltip]="processTooltip"
                                size="sm"
                                href="{{ legacyUrl }}Public/QuickQuote/{{ post.companyId }}/{{ post.t1 }}"
                                target="_blank"
                                >View</a
                            >
                        }
                        <!-- Spares quote -->
                        @case (44) {
                            <a
                                sfButton
                                icon="file-pen"
                                size="sm"
                                tooltip="View the certificate"
                                href="{{ legacyUrl }}Public/PartsQuote/{{ post.companyId }}/{{ post.t1 }}"
                                target="_blank"
                                >View</a
                            >
                        }
                        <!-- Smart quote -->
                        @case (73) {
                            <a
                                sfButton
                                icon="file-pen"
                                size="sm"
                                tooltip="View the certificate"
                                href="{{ legacyUrl }}Public/SmartQuote/{{ post.companyId }}/{{ post.t1 }}"
                                target="_blank"
                                >View</a
                            >
                        }
                        <!-- Smart quote -->
                        @case (74) {
                            <a
                                sfButton
                                icon="file-pen"
                                size="sm"
                                tooltip="View the certificate"
                                href="{{ legacyUrl }}Public/SmartQuote/{{ post.companyId }}/{{ post.t1 }}"
                                target="_blank"
                                >View</a
                            >
                        }
                        @default {
                            <a
                                sfButton
                                icon="file-pen"
                                size="sm"
                                tooltip="View the certificate"
                                href="{{ legacyUrl }}Public/Certificate/{{ post.companyId }}/{{ post.id }}"
                                target="_blank"
                                >View</a
                            >
                        }
                    }

                    <a sfButton icon="certificate" size="sm" tooltip="View the certificate" (click)="viewCertificate()"
                        >Certificate</a
                    >

                    @switch (post.postTypeId) {
                        <!-- Quote Wizard -->

                        @case (51) {
                            <a
                                sfButton
                                icon="cog"
                                size="sm"
                                [tooltip]="processTooltip"
                                href="{{ legacyUrl }}WizardQuote/Edit/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }
                        <!-- Quick quote -->

                        @case (45) {
                            <a
                                sfButton
                                icon="cog"
                                [tooltip]="processTooltip"
                                size="sm"
                                href="{{ legacyUrl }}QuickQuote/Edit/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }
                        <!-- Spares quote -->
                        @case (44) {
                            <a
                                sfButton
                                icon="cog"
                                [tooltip]="processTooltip"
                                size="sm"
                                href="{{ legacyUrl }}PartsArena/Edit/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }
                        <!-- Smart quote -->
                        @case (73) {
                            <a
                                sfButton
                                icon="cog"
                                [tooltip]="processTooltip"
                                size="sm"
                                routerLink="/smartquote/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }
                        <!-- Smart quote -->
                        @case (74) {
                            <a
                                sfButton
                                icon="cog"
                                [tooltip]="processTooltip"
                                size="sm"
                                routerLink="/smartquote/{{ post.t1 }}"
                                target="_blank"
                                >Process</a
                            >
                        }
                        @default {
                            <a
                                sfButton
                                icon="cog"
                                [tooltip]="processTooltip"
                                size="sm"
                                routerLink="/posts/{{ post.id }}"
                                >Process</a
                            >
                        }
                    }

                    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                        <button
                            sfButton
                            type="button"
                            size="sm"
                            color="secondary"
                            class="dropdown-toggle-split"
                            ngbDropdownToggle></button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                            @if (post.isVoided) {
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Mark this post as Unvoided"
                                    (click)="postStore.setPostVoid({ postId: post.id, isVoid: false })">
                                    Unvoid
                                </button>
                            } @else {
                                <button
                                    sfButton
                                    ngbDropdownItem
                                    tooltip="Mark this post as Voided"
                                    (click)="postStore.setPostVoid({ postId: post.id, isVoid: true })">
                                    Void
                                </button>
                            }
                            <button
                                sfButton
                                ngbDropdownItem
                                tooltip="Remove this post (will mark the post as Processed)"
                                (click)="postStore.removePost(post.id)">
                                Remove
                            </button>
                            <button
                                sfButton
                                ngbDropdownItem
                                tooltip="Delete this post will remove it from your database (irreversable)"
                                (click)="deletePost()">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #processTooltip>
    View the 'Process Post' screen to view the post details and email the certificate to the customer
</ng-template>
